import api from '@/api/config'

export default class homeServer {
    static async login(req) {
        return api.sendRequest({
            method: 'POST',
            url: '/login',
            data: req
        }).then(function (data) {
            return data
        })
    }
    // 上传
    static async uploadExcel(req) {
        return api.sendRequest({
            method: 'POST',
            url: '/uploadExcel',
            data: req
        }).then(function (data) {
            return data
        })
    }
    // 获取所有防伪码记录
    static async getCodeList(req) {
        return api.sendRequest({
            method: 'POST',
            url: '/getCodeList',
            data: req
        }).then(function (data) {
            return data
        })
    }
    // 获取所有防伪码记录
    static async initCode(req) {
        return api.sendRequest({
            method: 'POST',
            url: '/initCode',
            data: req
        }).then(function (data) {
            return data
        })
    }
}